import appConstants from '@appConstants';
import { shouldHandleAsTrailerMovePickup } from '../utils';

type TrailerMoveFlagPickup = {
  moveType?: string | null;
  isSwapPickup?: boolean | null;
  isDockDropPickup?: boolean | null;
};

type TrailerMovePickupEventData = TrailerMoveFlagPickup & {
  pickupId?: string;
  pickupIds?: string[];
  driverId?: string | null;
  data?: TrailerMoveFlagPickup & {
    driverId?: string | null;
  };
};

type SelectedTrailerMove = {
  pickupId?: string | null;
  driverId?: string | null;
  [key: string]: unknown;
};

type TrailerMovePickupDispatchStore = {
  selectedTrailerMove: SelectedTrailerMove | null;
  updatedSinglePickupInList: (pickupData: null, pickupId: string | undefined) => void;
  updateSelectedTrailerMove: (trailerMove: SelectedTrailerMove) => void;
};

/** Type check for SignalR emit — callers that need the feature flag use shouldHandleAsTrailerMovePickupEvent. */
export const isTrailerMovePickupEvent = (
  pickupData?: TrailerMovePickupEventData | null
): boolean =>
  shouldHandleAsTrailerMovePickup(pickupData, true) ||
  shouldHandleAsTrailerMovePickup(pickupData?.data, true);

/** Only route trailer-move SignalR onto Swap Board when the feature flag is on. */
export const shouldHandleAsTrailerMovePickupEvent = (
  pickupData: TrailerMovePickupEventData | null | undefined,
  enableTrailerSwapBoard: boolean | null | undefined
): boolean =>
  shouldHandleAsTrailerMovePickup(pickupData, enableTrailerSwapBoard) ||
  shouldHandleAsTrailerMovePickup(pickupData?.data, enableTrailerSwapBoard);

export const getTrailerMovePickupIds = (
  pickupData: TrailerMovePickupEventData
): (string | undefined)[] => {
  if (pickupData.pickupIds && pickupData.pickupIds.length > 1) {
    return pickupData.pickupIds;
  }
  return [pickupData.pickupId];
};

export const handleTrailerMovePickupSuccess = (
  DispatchStore: TrailerMovePickupDispatchStore,
  pickupData: TrailerMovePickupEventData,
  eventName: string
): void => {
  const pickupIds = getTrailerMovePickupIds(pickupData);
  pickupIds.forEach((pickupId) => {
    DispatchStore.updatedSinglePickupInList(null, pickupId);
  });

  const selectedTrailerMove = DispatchStore.selectedTrailerMove;
  const selectedPickupId = selectedTrailerMove?.pickupId?.toUpperCase();
  const matchesSelectedTrailerMove = pickupIds.some(
    (pickupId) => pickupId?.toUpperCase() === selectedPickupId
  );

  if (!selectedTrailerMove || !matchesSelectedTrailerMove) {
    return;
  }

  const isAssign = eventName === appConstants.PICKUP_EVENTS.ASSIGN_PICKUP;
  const isUnassign = eventName === appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP;
  const nestedPickupData = pickupData.data ?? {};
  const assignedDriverId = pickupData.driverId ?? nestedPickupData.driverId ?? null;
  let driverId = selectedTrailerMove.driverId;
  if (isAssign) {
    driverId = assignedDriverId;
  } else if (isUnassign) {
    driverId = null;
  }
  DispatchStore.updateSelectedTrailerMove({
    ...selectedTrailerMove,
    driverId,
  });
};
